import { useContext } from 'react'

import { store } from '../Context/Store'

const useStories = () => {
  const {
    globalState: { siteData }
  } = useContext(store)

  const storiesList = siteData?.allGeneral

  const getStoryById = id => storiesList.filter(story => story.id === id)

  const getStoriesByTag = tag => storiesList.filter(story => story?.tags?.includes(tag))

  return {
    stories: storiesList,
    getStoryById,
    getStoriesByTag
  }
}

export default useStories
